import React, { PureComponent, Suspense } from "react";
import { WIDGETS } from "../constants/widgets";
import PropTypes from "prop-types";
import MediaContainer from "./MediaContainer";
import ModalContainer from "../containers/ModalContainer";
import styled from "styled-components";
import { cssMainSelector } from "../lib/cssSelectors";

function widget(id) {
  switch (id) {
    case WIDGETS.inDepth_default_combi.id:
      return InDepthDefaultCombiWidget;
    case WIDGETS.inDepth_default_phoneOffer.id:
      return InDepthDefaultPhoneOfferWidget;
    case WIDGETS.inDepth_default_proposition.id:
      return InDepthDefaultPropositionWidget;
    case WIDGETS.inDepth_default_simOnly.id:
      return InDepthDefaultSimOnlyWidget;
    case WIDGETS.topList_default_proposition.id:
      return TopListDefaultPropositionWidget;
    case WIDGETS.topList_default_simOnly.id:
      return TopListDefaultSimOnlyWidget;
    case WIDGETS.topList_inArticle_proposition.id:
      return TopListInArticlePropositionWidget;
    case WIDGETS.topList_inArticle_simOnly.id:
      return TopListInArticleSimOnlyWidget;
    default:
      return InDepthDefaultSimOnlyWidget;
  }
}

const InDepthDefaultCombiWidget = React.lazy(() =>
  import("./widgets/inDepth/default/combi/Widget")
);
const InDepthDefaultPhoneOfferWidget = React.lazy(() =>
  import("./widgets/inDepth/default/phoneOffer/Widget")
);
const InDepthDefaultPropositionWidget = React.lazy(() =>
  import("./widgets/inDepth/default/proposition/Widget")
);
const InDepthDefaultSimOnlyWidget = React.lazy(() =>
  import("./widgets/inDepth/default/simOnly/Widget")
);
const TopListDefaultPropositionWidget = React.lazy(() =>
  import("./widgets/topList/default/proposition/Widget")
);
const TopListDefaultSimOnlyWidget = React.lazy(() =>
  import("./widgets/topList/default/simOnly/Widget")
);
const TopListInArticlePropositionWidget = React.lazy(() =>
  import("./widgets/topList/inArticle/proposition/Widget")
);
const TopListInArticleSimOnlyWidget = React.lazy(() =>
  import("./widgets/topList/inArticle/simOnly/Widget")
);

const BackgroundContainer = styled.div`
  ${p => cssMainSelector(p.theme.tdsId)} {
    background-color: ${p => p.theme.background.color};
  }
`;

class Widget extends PureComponent {
  render() {
    const {
      clientConfig,
      offerType,
      portal,
      selectedEntity,
      sponsoredPositionCount,
      updateExperiment,
      updateModal
    } = this.props;
    const SelectedWidget = widget(clientConfig.widget);
    const widgetData = WIDGETS[clientConfig.widget];

    return (
      <MediaContainer outer={true}>
        <BackgroundContainer>
          <ModalContainer />
          <Suspense fallback={<div> </div>}>
            <SelectedWidget
              clientConfig={clientConfig}
              offerType={offerType}
              portal={portal}
              selectedEntity={selectedEntity}
              sponsoredPositionCount={sponsoredPositionCount}
              updateExperiment={updateExperiment}
              updateModal={updateModal}
              widgetOptions={widgetData.options}
            />
          </Suspense>
        </BackgroundContainer>
      </MediaContainer>
    );
  }
}

Widget.propTypes = {
  clientConfig: PropTypes.object.isRequired,
  offerType: PropTypes.string.isRequired,
  portal: PropTypes.object.isRequired,
  sponsoredPositionCount: PropTypes.number,
  updateExperiment: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
  updateModal: PropTypes.func
};

Widget.defaultProps = {
  sponsoredPositionCount: 0
};

export default Widget;
